"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GaugeChart;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pie = require("@nivo/pie");

var _consts = require("../../utils/consts");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "GaugeDisplay__Container",
  componentId: "v5nuga-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-flow:column nowrap;margin:0;padding:0;width:100%;height:100%;span{color:", ";}"], props.theme.color.text);
});

var MinValue = _styledComponents["default"].span.withConfig({
  displayName: "GaugeDisplay__MinValue",
  componentId: "v5nuga-1"
})(["text-align:", ";"], function (props) {
  return props.align === _consts.align.left ? 'right' : 'left';
});

var MaxValue = _styledComponents["default"].span.withConfig({
  displayName: "GaugeDisplay__MaxValue",
  componentId: "v5nuga-2"
})(["text-align:", ";"], function (props) {
  return props.align;
});

var ChartContainer = _styledComponents["default"].div.withConfig({
  displayName: "GaugeDisplay__ChartContainer",
  componentId: "v5nuga-3"
})(["position:relative;width:100%;height:calc(100% - 2rem);justify-self:center;"]);

var Needle = _styledComponents["default"].div.withConfig({
  displayName: "GaugeDisplay__Needle",
  componentId: "v5nuga-4"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;height:100%;width:0.125rem;border-radius:2px;background:", ";transform-origin:bottom;bottom:0;", " &::after{content:'';display:block;position:relative;top:calc(100% - 0.5rem);right:0.5rem;height:1rem;width:1rem;border-radius:50%;background:", ";opacity:0.8;}@supports (-ms-ime-align:auto){display:none;opacity:0;clip-path:circle(0);}"], props.theme.color.text, props.align === _consts.align.right ? (0, _styledComponents.css)(["right:1rem;transform:rotate(", "deg);"], -props.angle) : (0, _styledComponents.css)(["left:1rem;transform:rotate(", "deg);"], props.angle), props.theme.color.structure);
});

var calculateAngle = function calculateAngle(value, min, max) {
  return Math.min(Math.max(90 - (value - min) * 90 / (max - min), 0), 90);
};

var alignment = function alignment(align) {
  return align === _consts.align.right ? {
    startAngle: 270,
    endAngle: 360
  } : {
    startAngle: 90,
    endAngle: 0
  };
};
/**
 *
 * #### Gauge Display Component

This component allows to present data in form of a gauge display chart. It is a part of GaugeChart Component.
 */


function GaugeChart(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? 10 : _ref$value,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$pattern = _ref.pattern,
      pattern = _ref$pattern === void 0 ? 'lavender' : _ref$pattern,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? _consts.align.left : _ref$align;

  var theme = _react["default"].useContext(_styledComponents.ThemeContext);

  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(MaxValue, {
    "aria-hidden": "true",
    align: align
  }, max), /*#__PURE__*/_react["default"].createElement(ChartContainer, null, /*#__PURE__*/_react["default"].createElement(_pie.ResponsivePie, _extends({
    data: [{
      id: 'full',
      label: '',
      value: value - min
    }, {
      id: 'empty',
      label: '',
      value: max - value
    }],
    fit: true
  }, alignment(align), {
    innerRadius: 0.5,
    cornerRadius: 2,
    colors: ['#F1F1F1'],
    borderWidth: 0,
    enableRadialLabels: false,
    enableSliceLabels: false,
    isInteractive: false,
    defs: [(0, _consts.pattern)(theme)[pattern]],
    fill: [{
      match: {
        id: 'full'
      },
      id: (0, _consts.pattern)(theme)[pattern].id
    }],
    legends: [{
      itemOpacity: 0,
      anchor: 'top-left',
      direction: 'column',
      translateX: -125,
      translateY: -40,
      itemWidth: 100,
      itemHeight: 32,
      itemTextColor: theme.color.text,
      symbolSize: 24,
      borderColor: theme.color.focus,
      effects: [{
        on: 'hover',
        style: {
          itemTextColor: theme.color.action
        }
      }]
    }]
  })), /*#__PURE__*/_react["default"].createElement(Needle, {
    align: align,
    angle: calculateAngle(value, min, max)
  })), /*#__PURE__*/_react["default"].createElement(MinValue, {
    "aria-hidden": "true",
    align: align
  }, min));
}